import { useNavigate, useRevalidator } from "react-router-dom";

import { useAppContext } from "@/App";
import { useRequest } from "@components/AppHook";
import { buildGetParamsFromApiData, buildQS, getEventSubmitter, scroll_to_top } from "@components/Utils";

export function fieldChange(props) {
    const { prefix, apiData, setApiData, name, val } = props;
    const newApiData = { ...apiData };
    newApiData.forms_data[prefix].data[name] = val;
    delete newApiData.forms_data[prefix].errors[name];
    setApiData(newApiData);
}

export function buildFormData({ ev, submitPrefixes, apiData }) {
    if (!ev) {
        alert("Ошибка");
        return;
    }

    const bodyFormData = new FormData();

    const { tn, tv } = getEventSubmitter(ev);
    if (tn && tv) {
        bodyFormData.append(tn, tv);
    }

    for (const prefix of submitPrefixes) {
        const form = apiData.forms_data[prefix];
        // данные форм
        for (const [name, val] of Object.entries(form.data)) {
            if (Array.isArray(val)) {
                // для мультиселектов, файлов
                val.forEach((v) => {
                    bodyFormData.append(`${form.prefix}-${name}`, v);
                });
            } else {
                bodyFormData.append(`${form.prefix}-${name}`, val);
            }
        }
    }

    return bodyFormData;
}

/**
 * Хук useSubmit для сабмита форм.
 * Использует глобальные стейты и проставляет стейт setApiIsLoading, на основе данных сабмиттера.
 * Это позволяет автоматически отслеживать состояние спиннера в SpinnerButton.
 */
export const useSubmit = (props = {}) => {
    const { submitUrl, submitMethod } = props;
    const { apiData, setApiData, apiUrl, setApiIsLoading } = useAppContext();
    const navigate = useNavigate();
    const revalidator = useRevalidator();
    const { api_post_formdata } = useRequest();

    return (ev, clickProps = {}) => {
        const { backUrl, submitPrefixes, onOK, onFinally } = clickProps;

        ev.preventDefault();

        const spr = submitPrefixes || Object.keys(apiData.forms_data || {});
        if (!spr.length) {
            alert("Internal error. Submit prefixes missing");
            return;
        }

        if (submitMethod === "get") {
            const prefix = spr[0];
            const getParams = buildGetParamsFromApiData({ apiData, prefix });
            const { tn, tv } = getEventSubmitter(ev);
            if (tn) {
                setApiIsLoading(tn ? tn + "-" + tv : true);
                getParams[tn] = tv;
            }
            navigate({ search: "?" + buildQS(getParams) });
        } else {
            const url = submitUrl || apiUrl;
            const formData = buildFormData({ ev, apiData, submitPrefixes: spr });
            api_post_formdata(ev, url, formData, {
                then: (resp) => {
                    if (resp.status === "ok") {
                        revalidator.revalidate();

                        if (onOK) {
                            onOK(resp);
                        } else if (backUrl) {
                            setApiData(undefined);
                            navigate(backUrl);
                        } else {
                            setApiData(resp);
                        }
                        scroll_to_top();
                    } else if (resp.forms_data) {
                        // костыль для файловых полей
                        for (const prefix of spr) {
                            const form = apiData.forms_data[prefix];
                            for (const [name, field] of Object.entries(form.fields)) {
                                const cur_val = form.data[name];
                                if (field.widget.input_type === "file" && cur_val) {
                                    resp.forms_data[form.prefix].data[name] = cur_val;
                                }
                            }
                        }
                        setApiData(resp);
                        scroll_to_top();
                    }
                },
                finally: () => {
                    if (onFinally) {
                        onFinally();
                    }
                },
            });
        }
    };
};
